// 1. 외부 패키지


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import { onError } from "../../shared/function";

// 4. 타입

interface Props {
	src: string;
}

const LeftImge = (props: Props) => {
	return (
		<img
			src={props.src}
			alt='분양 basic 이미지'
			onError={(e) => {
				onError(e, 'large');
			}}
			onContextMenu={(e) => {
				e.preventDefault();
			}}
		/>
	);
};

export default LeftImge;